<template>
    <viewer class="img-record">
        <img :src="src" style="width: auto;height: auto;max-width: 30%;border-radius: 0%;margin-top: 5px;margin-right: 4px;"/>
    </viewer>
</template>
<script>
export default {
    props: {
        src: {
            type: String
        },
    },
}
</script>
<style lang="scss" scoped>
</style>